import { render, staticRenderFns } from "./index.vue?vue&type=template&id=848fe8aa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848fe8aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('848fe8aa')) {
      api.createRecord('848fe8aa', component.options)
    } else {
      api.reload('848fe8aa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=848fe8aa&scoped=true", function () {
      api.rerender('848fe8aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qrcode/index.vue"
export default component.exports